import { useState } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useMilestoneSets } from '@/hooks/useMilestoneSets';

interface DeleteMilestoneSetDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  milestoneSet: any;
}

export function DeleteMilestoneSetDialog({
  open,
  onOpenChange,
  milestoneSet,
}: DeleteMilestoneSetDialogProps) {
  const [loading, setLoading] = useState(false);
  const { deleteMilestoneSet } = useMilestoneSets();

  const handleDelete = async () => {
    if (!milestoneSet) return;

    try {
      setLoading(true);
      await deleteMilestoneSet(milestoneSet.id);
      onOpenChange(false);
    } catch (err) {
      console.error('Error deleting milestone set:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Milestone Set</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete "{milestoneSet?.name}"?
            {milestoneSet?.usage_count > 0 && (
              <span className="block mt-2 font-medium">
                This milestone set is used in {milestoneSet.usage_count} job{milestoneSet.usage_count > 1 ? 's' : ''}.
                Deleting it won't affect existing jobs.
              </span>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleDelete} disabled={loading} className="bg-destructive text-destructive-foreground hover:bg-destructive/90">
            {loading ? 'Deleting...' : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
